import React from 'react';
import { DomainVerificationStatus } from '../constants';
import { useGetDomainsQuery, useGetEmailDomainsQuery } from '../services/api';

export const useCustomDomains = () => {
  const { data: domains = [] } = useGetDomainsQuery();
  const { data: emailDomains = [] } = useGetEmailDomainsQuery();

  const isCustomDomainConnected = React.useMemo(() => {
    const anyCustomEmailDomain = emailDomains.find(
      d => d.id !== 'default' && d.status === DomainVerificationStatus.verified,
    );

    const anyCustomDomain = domains.find(
      d => d.id !== 'default' && d.status === DomainVerificationStatus.verified,
    );

    return !!anyCustomDomain || !!anyCustomEmailDomain;
  }, [domains, emailDomains]);

  const basePortalDomain = React.useMemo(() => {
    if (domains.length > 0) {
      const activeDomain = domains.find(x => x.isPrimary) ?? domains[0];
      return `${activeDomain.subdomain}.${activeDomain.domain}`;
    }
    return null;
  }, [domains]);

  return { domains, emailDomains, isCustomDomainConnected, basePortalDomain };
};
